import {Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {ContactUsService} from "../../../shared/services/contact-us.service";
import {AlertService} from "../../../shared/services/alert.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-ugms',
    templateUrl: './ugms.component.html',
    styleUrls: ['./ugms.component.scss']
})
export class UgmsComponent implements OnInit {
    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;
    powerfullToUse = [
        {text: 'Unified Platform'},
        {text: 'Process Automation'},
        {text: 'Live Data Insights'},
        {text: 'Robust & Flexible'},
        {text: 'Seamless Collaboration'},
        {text: 'Tailored Solutions'},
    ];
    features = [
        {icon: 'assets/img/project/admissions.png', text: 'Admissions Management'},
        {icon: 'assets/img/project/enrollment.png', text: 'Enrollment Management'},
        {icon: 'assets/img/project/examination.png', text: 'Document Management'},
        {icon: 'assets/img/project/finance.png', text: 'Lead Management\n'},
        {icon: 'assets/img/project/Recognitions.png', text: 'User Permissions'},
        {icon: 'assets/img/project/student-tracking.png', text: 'Finance Management'},
        {icon: 'assets/img/project/notifications.png', text: 'Real-Time Reports'},
        {icon: 'assets/img/project/branch-icon.png', text: 'Multi University Management'},

        {icon: 'assets/img/project/branch-icon.png', text: 'Multi-Branch Management'}

    ];
    whyChoose = [
        {
            header: 'Role-Based Access & Permissions',
            text: 'Our products are designed with role-based access and permissions, ensuring high-end data privacy and security that streamline management operations for administrators, faculty, staff, and students. '
        },
        {
            header: 'User-Friendly Interface',
            text: 'Our motto is to increase productivity and efficiency. Thus, we create user-centric products that allow users to navigate complex processes effortlessly without requiring extensive training.'
        },
        {
            header: 'Automated Notifications & Alerts',
            text: 'Experience real-time communications through automated notifications and alerts, ensuring everyone stays informed about new policies, rules, schedules, events, and work deadlines.'
        },
        {
            header: 'Advanced Security Features',
            text: ' Our focus is always on data security and safety. We use up-to-date tools and techniques to safeguard sensitive institutional information and multi-layered security protocols. '
        },
        {
            header: '24/7 Dedicated Support',
            text: 'We have a dedicated team of experts that always ready to provide any kind of assistance our customer requires, ensuring uninterrupted workflows and issue resolution.'
        },
        {
            header: 'Cost-Effective & Customizable Solutions',
            text: ' We are committed to providing full customer satisfaction. We offer budget-friendly products with vast customizable options to meet your institution’s specific needs and growth goals.'
        },
    ];

    offerings = [
        {
            text: 'Lifetime Free Maintenance'
        },
        {
            text: 'Personalized Assistance'
        },
        {
            text: 'Lifetime Free Maintenance Updates'
        },
        {
            text: 'Discounts on Extra Modules'
        },
        {
            text: 'Feedback and Feature Request'
        },
        {
            text: 'Third-Party Tool Integration'
        },
        {
            text: 'Consultation and Best Practices'
        },
        {
            text: 'Training Sessions'
        },
        {
            text: 'Resolution within 48 hours'
        },
        {
            text: 'Free Server'
        },
    ];

    constructor(
        private router: Router,
        private contactService: ContactUsService,
        private alertService: AlertService,
        private fb: FormBuilder,
        private meta : Meta,
        private title: Title,
        private renderer: Renderer2
    ) {
    }

    ngOnInit(): void {
        this.refresh();
        this.updateMetaTags();
        this.schema();
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            message: ['', Validators.required]
        });
    }
    schema() {
        const corporationSchema = {
            "@context": "https://schema.org",
            "@type": "UmsPage",
            "name": "Volmint Technology - Ums",
            "url": "https://www.volmint.com/ums",
            "logo": "https://www.volmint.com/assets/img/white-volmint-logo.png",

        };

        // FAQ Schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What makes Volmint's UMS user-friendly?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "   Our UMS features an intuitive interface designed for easy navigation, making it simple for administrators, faculty, and students to manage daily operations without any technical hurdles."
                    }
                },
                {
                    "@type": "Question",
                    "name": " How does your UMS ensure data security?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "  We prioritize data security with role-based access and advanced authentication  protocols, ensuring that sensitive information is protected across both web and mobile platforms."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can Volmint’s UMS be customized for specific university needs?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "     Yes, our UMS is highly customizable, allowing you to tailor modules and features to meet your institution’s unique requirements, ensuring a perfect fit for your operations."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How does Volmint's UMS streamline the admission process?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "  Our UMS automates the entire admission workflow, from application submission to  enrollment, making the process faster, more efficient, and error-free for both administrators and students."
                    }
                },
                {
                    "@type": "Question",
                    "name": " What support does Volmint Technologies offer after UMS implementation?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "  We provide 24/7 dedicated support to ensure your university’s operations remain\n" +
                            "                                uninterrupted. Our team is always available to assist with any issues or inquiries."
                    }
                },


            ]
        };

        // Add Corporation Schema
        const corpScript: HTMLScriptElement = this.renderer.createElement('script');
        corpScript.type = 'application/ld+json';
        corpScript.text = JSON.stringify(corporationSchema);
        this.renderer.appendChild(document.head, corpScript);

        // Add FAQ Schema
        const faqScript: HTMLScriptElement = this.renderer.createElement('script');
        faqScript.type = 'application/ld+json';
        faqScript.text = JSON.stringify(faqSchema);
        this.renderer.appendChild(document.head, faqScript);
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }

    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }


    goTo(url) {
        this.router.navigateByUrl(url);
    }

    updateMetaTags() {
        this.title.setTitle('Volmint’s UGMS - Effective University Group Management System');
        this.meta.updateTag({name: 'description', content: ' Simplify your university operations with Volmint’s University Group Management System for better interconnectivity and seamless university management.  '});
        this.meta.updateTag({name: 'keyword', content: 'interconnected university management system, university group management system, multi university management system, interconnected university management, university group management software, online university group management software, automated university group management system, online university department management system, inter university management system'});
    }

}
